import type { JSX } from "react";

import Tooltip from "ds/components/Tooltip";
import { Module } from "types/generated";
import ModuleVersionPageIntoTitle from "views/Account/Module/Version/components/PageIntoTitle";
import Toggle from "ds/components/Toggle";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import PageInfoHeaderActions from "ds/components/PageInfoHeader/Actions";
import useCanTriggerModuleVersion from "shared/Module/access/useCanTriggerModuleVersion";

import TriggerButton from "../TriggerButton";

type PageLayoutProps = {
  hideFailedVersions?: boolean;
  module?: Module;
  toggleHideFailedVersions?: () => void;
  children: React.ReactNode;
};

const PageLayout = ({
  hideFailedVersions,
  module,
  toggleHideFailedVersions,
  children,
}: PageLayoutProps): JSX.Element => {
  const displayToggle = hideFailedVersions !== undefined && toggleHideFailedVersions !== undefined;
  const canTriggerModuleVersion = useCanTriggerModuleVersion();

  const canTrigger = module && canTriggerModuleVersion(module).result;

  return (
    <>
      <PageInfoHeaderWrapper>
        <ModuleVersionPageIntoTitle title="Versions" tooltip="Published module versions" />
        <PageInfoHeaderActions>
          {displayToggle && (
            <Toggle
              variant="switch"
              onChange={toggleHideFailedVersions}
              isSelected={!hideFailedVersions}
            >
              Show failed versions
            </Toggle>
          )}
          {canTrigger && (
            <Tooltip
              on={(props) => (
                <span {...props}>
                  <TriggerButton moduleId={module.id} disabled={module.isDisabled} />
                </span>
              )}
              active={module.isDisabled}
            >
              Module is disabled
            </Tooltip>
          )}
        </PageInfoHeaderActions>
      </PageInfoHeaderWrapper>
      {children}
    </>
  );
};

export default PageLayout;
